import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import { Grid, Tooltip } from '@mui/material';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import CreateMuseum from './CreateMuseum';
import { museumApi, museumServicesAction } from '../../../services/MuseumServices';
import NoDataFound from '../../../common/NoDataFound/NoDataFound';
import HeaderActions from '../../../common/DasnboardHeader/HeaderActions';
import { truncate } from '../../../common/Functions/Truncate/Truncate';
import { Images } from '../../../common/Assets/Images';
import DashboardHeader from '../../../common/DasnboardHeader/DashboardHeader';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';

export default function Dashboard() {
  const [open, setOpen] = React.useState(false);
  const [museums, setMuseums] = useState([]);
  const [museumId, setMuseumId] = useState(null);
  const [meta, setMeta] = useState({});

  useEffect(() => {
    getMuseums();
  }, []);

  const getMuseums = () => {
    museumApi('get', null, { per_page: 25 }).then(res => {
      setMuseums(res?.data);
      setMeta(res?.meta);
    })
  }

  const handleOpen = () => {
    setOpen(true);
    setMuseumId(null);
  };

  const handleClose = () => {
    setOpen(false);
    setMuseumId(null);
  };

  const editMuseum = (id) => {
    setMuseumId(id);
    setOpen(true);
  }

  const deleteMuseum = (id) => {
    museumServicesAction('delete', id).then(res => {

    })
  }

  return (
    <React.Fragment>
      <Box sx={{ px: 3, py: 2 }}>
        {/* <HeaderActions title={'Museums'} handleOpen={handleOpen} btnName={'+ Add Museum'} /> */}
        <Box>
          <DashboardHeader total={meta?.total} IconName={AccountBalanceIcon} iconColor={'#ff9653'} desc={'Total Museums'} title={'Museums'} handleOpen={handleOpen} btnName={'+ Add Museum'} />
        </Box>
      </Box>
      <Box sx={{ px: 3 }}>
        <Carousel
          swipeable={true}
          draggable={true}
          showDots={false}
          autoPlay={!open}
          responsive={responsive}
          ssr={true}
          infinite={true}
          autoPlaySpeed={2000}
          keyBoardControl={true}
          customTransition="transform 500ms ease-in-out"
          transitionDuration={500}
          containerClass="carousel-container"
          removeArrowOnDeviceType={['tablet', 'mobile']}
          // removeArrowOnDeviceType={['both']}
          dotListClass="custom-dot-list-style"
          itemClass="carousel-item-padding-40-px"
        >
          {museums?.length > 0 ? (
            museums?.map((item, index) => (
              <Box key={index} className="carousel-item">
                <Box className={'position-relative'}>
                  <img
                    draggable={'false'}
                    src={item?.photos?.[0]?.file || Images?.noImage}
                    alt={item?.name}
                    loading="lazy"
                    style={{ width: '99%', height: 300, objectFit: "cover" }}
                  />
                  <Box className={'position-absolute'} sx={{ bottom: 12, left: 12, right: 0 }}>
                    <Grid container>
                      <Grid item sm={10}>
                        <Typography className={'text-capitalize text-shadow white-color font-16 text-bold'}>{item?.name}</Typography>
                        <Typography
                          className={'text-shadow white-color font-14'}>{item?.gewog_name + ', ' + item?.dzongkhag_name + ' Bhutan' || 'Nil'}</Typography>
                      </Grid>
                      <Grid item sm={2}>
                        <Tooltip title={'Edit'}>
                          <IconButton onClick={() => editMuseum(item?.id)} sx={{
                            bgcolor: '#E9EFFB',
                            '&:hover': {
                              bgcolor: '#f3f5fa',
                            },
                          }}>
                            <DriveFileRenameOutlineIcon sx={{ color: '#3D3D3D' }} />
                          </IconButton>
                        </Tooltip>
                      </Grid>
                    </Grid>
                  </Box>
                </Box>
                <div style={{ padding: 10 }}>
                  <Typography style={{ color: '#727272', textAlign: 'justify' }}>{truncate(item.description, 250)}</Typography>
                </div>
              </Box>
            ))
          ) : (
            <div style={{ width: '100vw' }}>
              <NoDataFound width={'20%'} height={'20%'} />
            </div>
          )}
        </Carousel>
      </Box>
      {open &&
        <CreateMuseum open={open} handleAction={handleClose} museumId={museumId} museums={museums} setMuseums={setMuseums} />}
    </React.Fragment>
  );
}

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 5
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    draggable: true
  }
};